const RoleEnum = Object.freeze({
  SUPER_ADMIN: 1,
  PROJECT_OWNER: 2,
  RESEARCHER: 3,
  PROJECT_ADMIN: 4
});

export default (RoleEnum);
